class GrowwLivePriceService {
  constructor() {
    this.intervalId = null;
    this.inFlight = false;
    this.sourceSymbols = new Map();
    this.subscribers = new Set();
    this.intervalMs = 1000;
    this.defaultSource = "__default__";
    console.log("kkkkk ✅ Service initialized");
  }

  normalizeSymbols = (symbols = []) => {
    console.log("kkkkk normalizeSymbols input:", symbols);
    const unique = Array.from(new Set(symbols.filter(Boolean)));
    console.log("kkkkk normalizeSymbols output:", unique);
    return unique;
  };

  getMergedSymbols = () => {
    console.log("kkkkk getMergedSymbols called");
    const merged = [];
    this.sourceSymbols.forEach((symbols, key) => {
      console.log("kkkkk sourceSymbols entry:", key, symbols);
      if (Array.isArray(symbols) && symbols.length) {
        merged.push(...symbols);
      }
    });
    const result = this.normalizeSymbols(merged);
    console.log("kkkkk mergedSymbols result:", result);
    return result;
  };

  setSymbols(sourceOrSymbols = [], maybeSymbols) {
    console.log("kkkkk setSymbols called:", sourceOrSymbols, maybeSymbols);

    let source = this.defaultSource;
    let symbols = sourceOrSymbols;

    if (typeof sourceOrSymbols === "string") {
      source = sourceOrSymbols || this.defaultSource;
      symbols = maybeSymbols || [];
    }

    const unique = this.normalizeSymbols(Array.isArray(symbols) ? symbols : []);

    if (unique.length === 0) {
      console.log("kkkkk removing source:", source);
      this.sourceSymbols.delete(source);
      return;
    }

    console.log("kkkkk setting source:", source, "symbols:", unique);
    this.sourceSymbols.set(source, unique);
  }

  subscribe(callback) {
    console.log("kkkkk subscribe called");
    if (typeof callback !== "function") return () => {};
    this.subscribers.add(callback);
    console.log("kkkkk total subscribers:", this.subscribers.size);
    return () => {
      console.log("kkkkk unsubscribe called");
      this.subscribers.delete(callback);
    };
  }

  startPolling(intervalMs = 1000) {
    console.log("kkkkk startPolling called with:", intervalMs);

    this.intervalMs = intervalMs;
    if (this.intervalId) {
      console.log("kkkkk polling already running");
      return;
    }

    this.pollOnce();
    this.intervalId = setInterval(() => {
      console.log("kkkkk interval tick");
      this.pollOnce();
    }, this.intervalMs);
  }

  stopPolling(source) {
    console.log("kkkkk stopPolling called with:", source);

    if (typeof source === "string" && source.trim()) {
      this.sourceSymbols.delete(source.trim());
      console.log("kkkkk removed source:", source);

      if (this.sourceSymbols.size > 0) {
        console.log("kkkkk still have active sources, not stopping interval");
        return;
      }
    } else if (source === null) {
      console.log("kkkkk clearing all sources");
      this.sourceSymbols.clear();
    }

    if (this.intervalId) {
      console.log("kkkkk clearing interval");
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  async pollOnce() {
    console.log("kkkkk 🚀 pollOnce triggered");

    const mergedSymbols = this.getMergedSymbols();

    if (this.inFlight) {
      console.log("kkkkk ⛔ skipped: request already in flight");
      return;
    }

    if (mergedSymbols.length === 0) {
      console.log("kkkkk ⛔ skipped: no symbols");
      return;
    }

    console.log("kkkkk symbols to request:", mergedSymbols);

    const sharedRaw = localStorage.getItem("sharedData");
    console.log("kkkkk sharedData raw:", sharedRaw);

    const shared = JSON.parse(sharedRaw || "null");
    console.log("kkkkk sharedData parsed:", shared);

    // const email = shared?.email || shared?.Email;
    const email =
    shared?.email ||
    shared?.Email ||
    shared?.user?.email;   // ✅ THIS IS YOUR CASE

    if (!email) {
      console.log("kkkkk ⛔ skipped: email missing");
      return;
    }

    console.log("kkkkk using email:", email);

    const url = "https://pmsapi.infomanav.in/api/v1/grow/ltp";
    console.log("kkkkk calling API:", url);

    this.inFlight = true;

    try {
      console.log("kkkkk 📡 sending request...");

      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          symbols: mergedSymbols,
        }),
      });

      console.log("kkkkk 📥 response received:", response);

      const data = await response.json();
      console.log("kkkkk 📦 response JSON:", data);

      const status = String(data?.data?.status || "").toLowerCase();
      const payload = data?.data?.ltp || {};

      console.log("kkkkk parsed status:", status);
      console.log("kkkkk parsed payload:", payload);

      const isSuccess = status === "success";
      console.log("kkkkk isSuccess:", isSuccess);

      if (isSuccess && payload && typeof payload === "object") {
        console.log("kkkkk ✅ notifying subscribers");

        this.subscribers.forEach((cb, idx) => {
          console.log("kkkkk calling subscriber:", idx);
          cb(payload);
        });
      } else {
        console.log("kkkkk ❌ API success false or invalid payload");
      }
    } catch (error) {
      console.log("kkkkk ❌ fetch error:", error);
    } finally {
      this.inFlight = false;
      console.log("kkkkk 🔄 request finished, inFlight reset");
    }
  }
}

const growwLivePriceService = new GrowwLivePriceService();
export default growwLivePriceService;